howspace.components.avatar = (() => {
    'use strict';

    const startZoomTimeout = (e) => {
        const avatar = $(e.currentTarget);
        if (avatar.hasClass('no-zoom') || avatar.hasClass('zoomed') || avatar.hasClass('zoom-clone')) {
            return;
        }

        if (avatar.data('zoom-timeout-id')) {
            clearTimeout(avatar.data('zoom-timeout-id'));
        }

        avatar.data('zoom-timeout-id', setTimeout(() => {
            zoomAvatar(avatar);
        }, 500));

        avatar.one('mouseleave click contextmenu', () => {
            if (avatar.data('zoom-timeout-id')) {
                clearTimeout(avatar.data('zoom-timeout-id'));
                avatar.removeData('zoom-timeout-id');
            }
        });
    };

    const zoomAvatar = (avatar) => {
        avatar.removeData('zoom-timeout-id');

        const rect = avatar[0].getBoundingClientRect();
        const clone = avatar.clone();
        clone.css({
            position: 'fixed',
            top: rect.top + 'px',
            left: rect.left + 'px',
            margin: 0,
        });

        avatar.addClass('zoomed');
        clone.addClass('zoom-clone');
        avatar.append(clone);

        if (howspace.isFeatureSupported('popover') && clone[0].isConnected) {
            clone.attr('popover', 'manual');
            clone[0].showPopover();
        }

        // Wait until the next animation frame to ensure the clone is in the DOM before applying the zoomed class.
        // Otherwise, the CSS transition will not apply correctly.
        requestAnimationFrame(() => {
            clone.addClass('zoomed');
        });

        // Start the zoom out animation once the mouse leaves the zoom clone, remove the clone after the transition ends.
        clone.one('mouseleave click', () => {
            avatar.removeClass('zoomed');
            clone.removeClass('zoomed');
            clone.one('transitionend', () => {
                clone.remove();
            });
        });

        // Remove the zoomed class and clone immediately on scroll.
        document.addEventListener('scroll', () => {
            avatar.removeClass('zoomed');
            clone.remove();
        }, {passive: true, once: true});
    };

    real.dom.$body.on('mouseenter', '.avatar-container.viewable', startZoomTimeout);

    return {
        // No public methods defined yet.
    };
})();
